import React from 'react';
import useComparePerMonthPerYearTotalChart from './hooks/useComparePerMonthPerYearTotalChart';
import ChartContainer from '../../Dashboards/Common/Services/charts/apex-charts/ChartContainer';

export const ComparePerMonthPerYearTotal = ({ height = 400 }) => {
    const { chartConfig } = useComparePerMonthPerYearTotalChart();

    return (
        <ChartContainer
            title={`Evolução Anual dos Débitos e Créditos`}
            options={chartConfig.options}
            series={chartConfig.series}
            height={height}
            className='chart-container-resume'
        />
    );
};
